var VIEW_MODES = /*#__PURE__*/ function(VIEW_MODES) {
    VIEW_MODES[VIEW_MODES["AGENDA"] = 1] = "AGENDA";
    VIEW_MODES[VIEW_MODES["WORK_WEEK"] = 2] = "WORK_WEEK";
    VIEW_MODES[VIEW_MODES["WEEK"] = 3] = "WEEK";
    return VIEW_MODES;
}(VIEW_MODES || {});
var MEETING_TIME_STATUSES = /*#__PURE__*/ function(MEETING_TIME_STATUSES) {
    MEETING_TIME_STATUSES[MEETING_TIME_STATUSES["NORMAL"] = 0] = "NORMAL";
    MEETING_TIME_STATUSES[MEETING_TIME_STATUSES["MEETING_TIME"] = 1] = "MEETING_TIME";
    MEETING_TIME_STATUSES[MEETING_TIME_STATUSES["BEFORE_MEETING_TIME"] = 2] = "BEFORE_MEETING_TIME";
    return MEETING_TIME_STATUSES;
}(MEETING_TIME_STATUSES || {});
var MEETING_RESPONSES = /*#__PURE__*/ function(MEETING_RESPONSES) {
    MEETING_RESPONSES[MEETING_RESPONSES["ACCEPTED"] = 0] = "ACCEPTED";
    MEETING_RESPONSES[MEETING_RESPONSES["TENTATIVE"] = 1] = "TENTATIVE";
    MEETING_RESPONSES[MEETING_RESPONSES["DECLINED"] = 2] = "DECLINED";
    MEETING_RESPONSES[MEETING_RESPONSES["NOT_RESPONDED"] = 3] = "NOT_RESPONDED";
    return MEETING_RESPONSES;
}(MEETING_RESPONSES || {});
/**
 * Graph marks an instance of a recurring series as `type: 'occurrence'`, and a rescheduled
 * instance of one as `type: 'exception'` — both are part of the series, which is how the 1:many
 * page's occurrence timeline already reads them. Centralised so the recurrence mark cannot drift
 * between the lists, the recap header and the transcript modal. Lives here rather than in
 * meetingHelper because that module pulls i18next and the identity store into whatever imports it.
 */ var RECURRING_INSTANCE_TYPES = [
    'occurrence',
    'exception'
];
var isRecurringMeeting = function isRecurringMeeting(meeting) {
    var _ref;
    return RECURRING_INSTANCE_TYPES.includes((_ref = meeting === null || meeting === void 0 ? void 0 : meeting.type) !== null && _ref !== void 0 ? _ref : '');
};
export { VIEW_MODES, MEETING_RESPONSES, MEETING_TIME_STATUSES, isRecurringMeeting };
